<template>
  <div class="wrapper">
    <router-view></router-view>

    <div class="animated fadeIn">
      <div class="card" v-if="['contents'].indexOf($route.name) > -1">
        <div class="card-header"><i class="icon-notebook"></i> Contenus</div>
        <div class="card-block">
          <table class="table table-condensed">
            <tbody>
              <tr v-if="hasPermission(user, 'DYNAMIC_CONTENT_READ')">
                <td>
                  <router-link to="/contents/dynamic-content"
                    >Contenus clients & coachs</router-link
                  >
                </td>
              </tr>
              <tr v-if="hasPermission(user, 'FAQ_READ')">
                <td>
                  <router-link to="/contents/faq"
                    >Questions/Réponses</router-link
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState({
      user: (state) => state.user,
    }),
  },
};
</script>
